import type { CustomerAccount, CustomerAccountInsert } from '@/types/customer-accounts';
import type { Location } from '@/types/location';

const mockCustomerAccounts: CustomerAccount[] = [
  {
    id: 'account-cannaplanet',
    account_key: 'cannaplanet',
    account_label: 'Canna Planet',
    legal_entity_name: 'RBBS Management',
    primary_location_id: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    created_by: null,
    updated_by: null,
  },
  {
    id: 'account-lazy-river',
    account_key: 'lazy-river',
    account_label: 'Lazy River',
    legal_entity_name: null,
    primary_location_id: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    created_by: null,
    updated_by: null,
  },
];

function slugAccountKey(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export const mockCustomerAccountsService = {
  async getAll(): Promise<CustomerAccount[]> {
    return [...mockCustomerAccounts].sort((a, b) => a.account_label.localeCompare(b.account_label));
  },

  async getByAccountKey(accountKey: string): Promise<CustomerAccount | null> {
    return mockCustomerAccounts.find((account) => account.account_key === accountKey) ?? null;
  },

  async create(data: CustomerAccountInsert): Promise<CustomerAccount> {
    const account: CustomerAccount = {
      id: `account-${Date.now()}`,
      account_key: data.account_key,
      account_label: data.account_label,
      legal_entity_name: data.legal_entity_name ?? null,
      primary_location_id: data.primary_location_id ?? null,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      created_by: null,
      updated_by: null,
    };
    mockCustomerAccounts.push(account);
    return account;
  },

  async ensureSingleStoreAccountForLocation(location: Location): Promise<CustomerAccount | null> {
    if (location.customer_account_id) return null;

    const accountKey =
      slugAccountKey(location.location_number) || slugAccountKey(location.location_name);
    if (!accountKey) return null;

    const existing = await this.getByAccountKey(accountKey);
    return existing ?? this.create({
      account_key: accountKey,
      account_label: location.location_name,
      primary_location_id: location.id,
    });
  },
};
